/* eslint-disable max-lines-per-function */
import { store } from "jiffy-store";
import { waitForDOM } from "common/utils/ui/wait_for";
import { isCustomizableMadePage } from "components/jiffy/product-details/customizable-made-page-utils";

const storeBasePathSelector = "meta[name='store::base_path']";

const loadPrices = (callback = null) => {
  const productId = $('[name="product_id"]').val();
  if (!productId) return;

  const getStoreURL = url => {
    const basePathElement = document.querySelector(storeBasePathSelector);
    const storeBasePath = basePathElement ? basePathElement.content : "";
    const printParam = isCustomizableMadePage() ? "?made_dedicated_pdp=true" : "";

    return storeBasePath + url + printParam;
  };

  const sendRequest = () => {
    $.ajax({
      type: "GET",
      url: getStoreURL(`/api/products/${productId}/cp`),
      tryCount: 0,
      retryLimit: 3,
      retryDelay: 10_000, // 10 seconds
      error(error) {
        if (error.status === 502 || error.status === 504) {
          this.tryCount += 1;
          if (this.tryCount <= this.retryLimit) {
            // Retry after some time with exponential back-off
            const delay = this.retryDelay * 2 ** (this.tryCount - 1);
            setTimeout(() => {
              $.ajax(this);
            }, delay);
          } else if (error && error.readyState !== 0) {
            // readyState 0 means the request was not sent
            // this typically means the user navigated away from the page or no connection
            window.Honeybadger.notify(`[JS] Error ${JSON.stringify(error)}`, {
              params: {
                productId
              }
            });
          }
        }
      },
      success(data) {
        store.pdp.change({ loadedPrices: data });
        callback && callback();
      }
    });
  };

  waitForDOM(storeBasePathSelector, sendRequest);
};

export default loadPrices;
